<template>
  <div class="flex flex-col gap-3">
    <EventsCard :event="event" />
    <div
      v-if="ticket.status === SubscriptionTicketStatus.Created"
      class="mt-auto"
    >
      <BaseButton @click="isTicketsActivationModalOpen = true">
        {{ $t('subscriptions.activate_ticket') }}
      </BaseButton>
    </div>
    <TicketsActivationModal
      v-if="isTicketsActivationModalOpen"
      :is-open="isTicketsActivationModalOpen"
      is-subscription
      :ticket-id="ticket.id"
      @close="isTicketsActivationModalOpen = false"
      @activated="emit('activated', ticket.id)"
    />
  </div>
</template>

<script setup lang="ts">
import type { SubscriptionTicket } from '~/models/subscriptions'
import { SubscriptionTicketStatus } from '~/models/subscriptions'
import type { EventLite } from '~/models/events'

interface Props {
  ticket: SubscriptionTicket
  event: EventLite
}

defineProps<Props>()

const emit = defineEmits(['activated'])

const isTicketsActivationModalOpen = ref(false)
</script>
